import FetchApi from "../../../customhooks/Functionapi";
const FetchApis = new FetchApi();

// ทุกฟังก์ชันคืน Promise : หน้าที่เรียกใช้ต้อง await ให้เสร็จก่อนเปลี่ยนหน้า (ถ้าไม่รอ request ที่ค้างอยู่จะถูกยกเลิก)

export function RejectGrouplist(datalist, uId) {

    return Promise.all(datalist.map(jourdatalist => {
        var datarejec = {
            journalId: jourdatalist.JournalID,
            UserId: uId,
            reject_stateflow: '1',
            rejectToId: jourdatalist.createBy
        }
        return FetchApis.FethcPost(`/flowrunsystem/updateReJectgroupflow`, datarejec).then(res => {
            console.log(res)
            return res;
        });
    }));
}

export function UpdateItemById(dataList) {

    return Promise.all(dataList.map(item => {
        var dataitem = {
            PkDescription: item.PkDescription,
            ItemID: item.ItemID,
            ItemName: item.ItemName,
            ItemGroupID: item.ItemGroupID
        }

        return FetchApis.FethcUpdate(`/document/updateDetailByItem/${item.JournalID}`, dataitem).then(res => {
            console.log(res)
        })

    }));

}

export function UpdateDetailBatch(dataList) {

    return Promise.all(dataList.map(item => {
        let dataobjec = {
            Batch1:item.Batch1,
            BatchDetail1:item.BatchDetail1,
            BatchExample1:item.BatchExample1,
            Batch2:item.Batch2,
            BatchDetail2:item.BatchDetail2,
            BatchExample2:item.BatchExample2,
            BatchNo:item.BatchNo,
            TypeBatch:item.TypeBatch
        }
        return FetchApis.FethcUpdate(`/document/updateDetailBatch/${item.JournalID}`, dataobjec).then(res => {
            console.log(res)
        })
    }))

}


export function NewNotereject(datalist) {
    return FetchApis.FethcPost(`/noterejectgroup/NoteRejectgroup`, datalist).then(res => {
        console.log(res)
    })
}
